/**
 * Override this file to register custom hooks in your implementation based on Algolia front end events.
 * Documentation: https://www.algolia.com/doc/integration/magento-2/customize/custom-front-end-events/
 **/
;
define("Algolia_AlgoliaSearch/hooks", function(){});

